import { render, staticRenderFns } from "./OnboardingPaymentInfoPage.vue?vue&type=template&id=3bd2eaeb&scoped=true&"
import script from "./OnboardingPaymentInfoPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingPaymentInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingPaymentInfoPage.vue?vue&type=style&index=0&id=3bd2eaeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2eaeb",
  null
  
)

export default component.exports